import React from 'react';
import {
  LibraryItemSortBy,
  Orientation,
} from '@wix/ambassador-file-sharing-v1-settings/types';
import { SortDown, SortUp } from '@wix/wix-ui-icons-common/on-stage';
import { TextButton, TextButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import { st, classes } from '../TableHeader.st.css';
import biService from '../../../../../../BiEvents/BiService';
import { BI_FILE_SHARE_WIDGET_SORT_BY } from '../../../../../../BiEvents/Constants/BiConstants';

const NameComponent = ({
  name,
  sortBy,
  orientation,
  handleTitleColumnOnClick,
  disabledTableHeader,
  isMembersArea,
}: any) => {
  const className = disabledTableHeader ? classes.disabledHeader : '';
  const suffixIcon: any =
    sortBy === LibraryItemSortBy.NAME &&
    (orientation === Orientation.DESC ? (
      <SortDown className={className} />
    ) : (
      <SortUp className={className} />
    ));
  return (
    <div
      style={{
        display: 'flex',
        fontSize: '14px',
        alignItems: 'center',
      }}
    >
      <TextButton
        className={st(classes.tableHeaderColumn, { isMembersArea })}
        suffixIcon={suffixIcon}
        priority={TextButtonPriority.secondary}
        onClick={() => {
          if (!disabledTableHeader) {
            handleTitleColumnOnClick({
              sortBy,
              selectedId: LibraryItemSortBy.NAME,
            });
            biService(
              { button_description: 'name', is_first: false },
              BI_FILE_SHARE_WIDGET_SORT_BY,
            );
          }
        }}
        title={name}
      >
        {name}
      </TextButton>
    </div>
  );
};
export default NameComponent;
